module.exports = __webpack_public_path__ + "img/headband.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/assets/img/products/headband.png
// module id = 375
// module chunks = 0